import classNames from 'classnames'
import { observer } from 'mobx-react'
import style from './UserWelcome.module.less'
import { Modal } from 'antd'
import { Z_INDEX_MAX } from '@/helpers/commonConsts'
import { commonUtils } from '@/helpers/commonUtils'
import { routerService } from '@/services/routerService'

/** UserWelcome 组件的 Props */
export type UserWelcomeProps = {
  open: boolean

  onClose?: () => void
}

type TabItem = {
  title: string
  icon: string
  id: string
}

const tabData: TabItem[] = [
  {
    title: '网页对照翻译',
    icon: 'home-page-v1/icon__web.png',
    id: 'translate',
  },
  {
    title: '划词翻译',
    icon: 'home-page-v1/icon__hover.png',
    id: 'select',
  },
  {
    title: 'PDF翻译',
    icon: 'home-page-v1/icon__pdf.png',
    id: 'pdf',
  },
  {
    title: '悬停翻译',
    icon: 'icon-hover-welcome.png',
    id: 'select',
  },
  {
    title: '学习模式',
    icon: 'home-page-v1/icon__learning.png',
    id: 'learn',
  },
  {
    title: '图片翻译',
    icon: 'icon-img-welcome.png',
    id: 'img',
  },
]

const UserWelcome = observer(({ open, onClose }: UserWelcomeProps) => {
  const onItemClick = (item: TabItem) => {
    if (item.id === 'pdf') {
      routerService.openNewTab('pdf_pro')
      return
    }

    if (item.id === 'img') {
      routerService.openNewTab('pdf', { tab: 'img' })
      return
    }

    routerService.openNewTab('home', { content: item.id })
  }

  return (
    <Modal
      zIndex={Z_INDEX_MAX}
      className={style.userWelcome}
      centered
      closable
      width={432}
      open={open}
      footer={false}
      onCancel={onClose}
    >
      <div className={style.content}>
        <p className={classNames(style.title)}>
          <img src={commonUtils.getStaticFile('icon__celebrate.png')} className={style.icon} />
          恭喜注册成功
        </p>
        <p className={classNames(style.desc)}>快去看看如何使用这些功能吧～</p>

        <div className={classNames(style.gridBox)}>
          {tabData.map((item, index) => {
            return (
              <div
                className={classNames(style.gridItem)}
                key={index}
                onClick={() => {
                  onItemClick(item)
                }}
              >
                <div className={classNames(style.gridItemIcon)}>
                  <img className={style.icon} src={commonUtils.getStaticFile(item.icon)} />
                </div>
                <p className={classNames(style.gridItemTitle)}>{item.title}</p>
                <img
                  className={style.arrow}
                  src={commonUtils.getStaticFile('arrow-right-welcome.png')}
                />
              </div>
            )
          })}
        </div>
      </div>
    </Modal>
  )
})

export default UserWelcome
